<template>
  <main class="container-fluid">
    <section class="row">
      <div class="col-6 px-3 py-3 d-none d-md-flex"></div>
      <div
        class="col-24 col-md-12 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
      >
        <div class="col d-column">
          <div class="card mb-3">
            <div class="card-body py-3">
              <div class="row">
                <div class="col-24">
                  <div
                    class="h-profile h-profile-lg d-flex flex-row no align-items-center justify-content-between"
                  >
                    <div>
                      <div
                        class="align-self-center d-flex align-items-center align-self-center pr-2 flex-wrap"
                      >
                        <object
                          width="62"
                          height="62"
                          class="rounded-circle img-lg mr-3"
                          :data="programData.avatar"
                          type="image/png"
                        >
                          <img
                            width="62"
                            height="62"
                            class="rounded-circle img-lg"
                            src="../../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>

                        <div class="d-flex flex-column">
                          <h1 class="title pt-1" v-text="programData.name"></h1>
                          <div class="title">
                            <span
                              v-text="
                                $ml
                                  .with(
                                    $utils.formatData(
                                      programData.createdAt,
                                      $ml.get('ln')
                                    )
                                  )
                                  .get('publishedDaysAgo')
                              "
                            >
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- <p v-text="$ml.with($utils.formatData(programData.updatedAt, $ml.get('ln'))).get('lastReviewSubmittedAgo')">Última revisão enviada em</p> -->
                    </div>
                    <div
                      v-if="campaign_situation == 'in_progress'"
                      class="d-flex flex-wrap justify-content-center"
                    >
                      <svg width="24" height="24">
                        <image
                          v-if="
                            double_reward.offers_double_bounty == true &&
                            double_reward.offers_double_score == false
                          "
                          xlink:href="../../../../src/assets/icons/icon-double-reward.svg"
                          width="24"
                          height="24"
                        />
                        <image
                          v-else-if="
                            double_reward.offers_double_score == true &&
                            double_reward.offers_double_bounty == false
                          "
                          xlink:href="../../../../src/assets/icons/icon-star.svg"
                          width="24"
                          height="24"
                        />
                        <image
                          v-else-if="
                            double_reward.offers_double_score == true &&
                            double_reward.offers_double_bounty == true
                          "
                          xlink:href="../../../../src/assets/icons/icon-diamante.svg"
                          width="24"
                          height="24"
                        />
                      </svg>

                      <div class="ml-2 text-left">
                        <label class="" v-text="$ml.get('boostedProgram')"
                          >Programa impulsionado</label
                        >
                        <div class="d-flex justify-content-end">
                          <label class="mr-2">
                            <label class="mr-1" v-text="$ml.get('start')"
                              >Inicío:</label
                            >{{ double_reward.campaign_initial_date }}</label
                          >
                          <label>
                            <label class="mr-1" v-text="$ml.get('finalDate')"
                              >Fim:</label
                            >{{ double_reward.campaign_final_date }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-column flex-row">
            <div
              class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
            >
              <div class="mt-3 d-flex align-self-start">
                <div
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>1</span>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="align-self-start mt-1">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('threats')">Ameaças</strong>
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('reportAllPossibleThreatData')"
                      >
                        Informe todos os dados possíveis das ameaças
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center flex-row">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100">
                  <div class="d-flex pl-3 w-100">
                    <div class="row w-100 d-flex">
                      <div class="form-group col-24 col-md-24">
                        <label v-text="$ml.get('reportTitle')"
                          >Título do relatório</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="title"
                          :placeholder="$ml.get('describeTheTitleOfTheReport')"
                          maxlength="300"
                          @keyup="saveCache('title')"
                        />
                        <transition name="fade">
                          <label
                            v-if="validateError && !$v.title.required"
                            class="lblError"
                            v-text="$ml.get('theTitleMustBeInformed')"
                            >O título precisa ser informado!</label
                          >
                          <label
                            class="lblError"
                            v-if="validateError && !$v.title.minLength"
                            v-text="
                              $ml
                                .with('f', 5)
                                .with('l', 100)
                                .get('theTitleMustBeBetweenCharacters')
                            "
                            >O título deve ter entre 5 e 100 caracteres!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Scope -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center flex-row">
                  <span class="circle-internal d-flex justify-content-center">
                    <span class="circle-primary"></span>
                  </span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100">
                  <div class="d-flex pl-3 w-100">
                    <div class="row w-100 d-flex">
                      <div class="form-group col-24 col-md-24">
                        <label
                          v-text="$ml.get('informTheScopeWhereTheThreatsAre')"
                          >Informe o escopo onde estão as ameaças
                        </label>
                        <multiselect
                          v-model="selectedScope"
                          label="name"
                          :options="selectScope"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$ml.get('informTheScope')"
                        >
                        </multiselect>
                        <transition name="fade">
                          <label
                            v-if="validateError && !$v.selectedScope.required"
                            class="lblError"
                            v-text="$ml.get('selectTheProgramScope')"
                            >Selecione o escopo do programa!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-self-start h-profile-circle">
                    <div
                      v-if="selectedScope?.id == 'isOutOfScope'"
                      class="row w-100 ml-3"
                    >
                      <div class="form-group col-24 col-md-24">
                        <label> Escopo inspecionado </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="alternativeScope"
                          :placeholder="$ml.get('describeTheScope')"
                          maxlength="200"
                        />
                        <transition name="fade">
                          <label
                            v-if="validateError && !alternativeScope"
                            class="lblError"
                          >
                            {{ $ml.get("enterTheScope") }}
                          </label>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-self-start h-profile-circle mb-4">
                    <div
                      v-if="selectedScope?.id == 'isOutOfScope'"
                      class="row w-100 ml-3"
                    >
                      <label v-text="$ml.get('selectTheScopeType')"
                        >Informe o tipo do escopo inspecionado
                      </label>
                      <multiselect
                        v-model="selectedScopeType"
                        label=""
                        :custom-label="nameLang"
                        :options="selectScopeType"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="$ml.get('scopeType')"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Target -->

              <div
                v-if="target_settings?.active"
                class="d-flex align-self-start h-profile"
              >
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div
                v-if="target_settings?.active && targetOptions.length"
                class="d-flex align-self-start h-profile-circle"
              >
                <div class="circle d-flex justify-content-center flex-row">
                  <span class="circle-internal d-flex justify-content-center">
                    <span class="circle-primary"></span>
                  </span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100">
                  <div class="d-flex pl-3 w-100">
                    <div class="row w-100 d-flex">
                      <div class="form-group col-24 col-md-24">
                        <label
                          v-text="$ml.get('selectAnObjectiveForTheReport')"
                        >
                          Qual o tipo de objetivo reportado
                        </label>
                        <multiselect
                          v-model="target"
                          label="title"
                          :options="targetOptions"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$ml.get('informTheTarget')"
                        >
                        </multiselect>
                        <transition name="fade">
                          <label
                            v-if="targetError"
                            class="lblError"
                            v-text="$ml.get('selectTheProgramTarget')"
                            >Selecione um objetivo do programa!</label
                          >
                        </transition>
                        <div v-if="target" class="card card-body mt-2">
                          <div class="box">
                            <p
                              v-html="
                                $utils.convertMarkedOld(
                                  showOriginalText
                                    ? target.policy
                                    : target.translated_policy
                                )
                              "
                            ></p>
                            <p class="m-0">
                              <span
                                class="bounty"
                                v-if="target.currency === 'BRL'"
                              >
                                {{ $utils.convertMoney(target.bounty) }}
                              </span>
                              <span v-else class="bounty">
                                {{ $utils.convertDollar(target.bounty) }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Impacto -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center flex-row">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>

                <div class="d-flex flex-column w-100 mr-3">
                  <div
                    class="card card-body ml-3 pl-3 d-flex w-100 pr-3"
                    style="z-index: 0"
                  >
                    <div class="itensCvss border p-2">
                      <h5 class="mb-3 mt-1">
                        {{ $ml.get("informTheImpact") }}
                      </h5>
                      <b-form-group>
                        <b-form-radio-group
                          buttons
                          @change="resetCvss = !resetCvss"
                        >
                          <b-form-radio
                            v-model="selectedImpact"
                            :value="{ id: 'low', name: 'low' }"
                            >{{ $ml.get("low") }}</b-form-radio
                          >
                          <b-form-radio
                            v-model="selectedImpact"
                            :value="{ id: 'medium', name: 'medium' }"
                            >{{ $ml.get("medium") }}</b-form-radio
                          >
                          <b-form-radio
                            v-model="selectedImpact"
                            :value="{ id: 'high', name: 'high' }"
                            >{{ $ml.get("high") }}</b-form-radio
                          >
                          <b-form-radio
                            v-model="selectedImpact"
                            :value="{ id: 'critical', name: 'critical' }"
                            >{{ $ml.get("critical") }}</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>

                    <label class="p-2 mt-2"
                      >{{ $ml.get("youCanCalculate") }}:</label
                    >

                    <!-- Calculadora CVSS-->
                    <cvss
                      class="border p-2"
                      @alterSeverity="alterSeverity"
                      :resetCvss="resetCvss"
                    >
                    </cvss>
                  </div>
                </div>
              </div>
              <!-- Threat -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center flex-row">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100">
                  <div class="d-flex pl-3 w-100">
                    <div class="row w-100 d-flex">
                      <div class="form-group col-24 col-md-24">
                        <label
                          >CWE -
                          <font v-text="$ml.get('selectTheVulnerability')"
                            >Informe a vulnerabilidade</font
                          ></label
                        >
                        <multiselect
                          v-model="selectedThreat"
                          label="external_id"
                          :options="selectThreat"
                          :close-on-select="true"
                          :show-labels="false"
                          :custom-label="nameWithLang"
                          :placeholder="$ml.get('select')"
                          @search-change="waitAPI"
                        >
                        </multiselect>
                        <p class="pt-1" v-if="selectedThreat">
                          {{ selectedThreat.description }}
                        </p>
                        <transition name="fade">
                          <label
                            v-if="validateError && !$v.selectedThreat.required"
                            class="lblError"
                            v-text="$ml.get('selectTheThreat')"
                            >Selecione a ameaça!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- abstract -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <label
                    class="pl-3 mb-3"
                    v-text="$ml.get('nowTellUsALittleBitAboutTheThreat')"
                  >
                    Agora nos fale um pouco da ameaça!
                  </label>
                  <div class="card card-body ml-3 pl-3 d-flex w-100 pr-3">
                    <div class="row">
                      <div class="col">
                        <textarea
                          class="form-control clear mb-1"
                          v-model="abstract"
                          rows="4"
                          maxlength="470"
                          :placeholder="
                            $ml.get('describeClearlyHowTheVulnerabilityWorks')
                          "
                          @keyup="saveCache('abstract')"
                        ></textarea>
                        <transition name="fade">
                          <label
                            v-if="validateError && !$v.abstract.required"
                            class="lblError"
                            v-text="
                              $ml.get('theThreatDescriptionMustBeInformed')
                            "
                            >A descrição da ameaça precisa ser informada!</label
                          >
                          <label
                            v-if="
                              (validateError && !$v.abstract.minLength) ||
                              !$v.abstract.maxLength
                            "
                            class="lblError"
                            v-text="
                              $ml
                                .with('f', 5)
                                .with('l', 500)
                                .get(
                                  'theThreatDescriptionMustBetweenCharacters'
                                )
                            "
                            >A descrição da ameaça deve ter entre 5 e 500
                            caracteres!</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- testes -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-5"></span>
                </div>
              </div>

              <div class="d-flex align-self-start">
                <div
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>2</span>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="align-self-start">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('tests')">Testes</strong>
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('describeThePerformedTests')"
                      >
                        Descreva quais foram os testes realizados
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <div class="card card-body ml-3 pl-3 d-flex w-100 pr-3">
                    <div class="row pt-1 pb-2">
                      <div class="col">
                        <div class="form-group">
                          <svg
                            v-show="!htmlText"
                            @click="viewHtml()"
                            width="24"
                            height="24"
                            class="ico-view-report"
                          >
                            <image
                              xlink:href="../../../../src/assets/icons/eye.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                          <svg
                            v-show="htmlText"
                            @click="htmlText = ''"
                            width="24"
                            height="24"
                            class="ico-view-report"
                          >
                            <image
                              xlink:href="../../../../src/assets/icons/eye-slash.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                          <textarea
                            v-show="!htmlText"
                            class="form-control text-are-mark"
                            rows="17"
                            maxlength="30000"
                            v-model="description"
                            @keyup="controlTextArea()"
                          >
                          </textarea>

                          <div
                            v-show="htmlText"
                            class="form-control h-100"
                            v-html="htmlText"
                          ></div>
                          <transition name="fade">
                            <label
                              v-if="validateError && !$v.description.required"
                              class="lblError"
                              v-text="
                                $ml.get('theDescriptionTestsMustBeInformed')
                              "
                              >A descrição dos testes precisa ser
                              informada!</label
                            >
                            <label
                              v-if="
                                validateError &&
                                !$v.description.descriptionMustBeCustomized
                              "
                              v-text="$ml.get('needChangeDescription')"
                              class="lblError"
                              >Utilize o molde para fazer uma descrição
                              detalhada.</label
                            >
                            <label
                              v-else-if="
                                validateError && !$v.description.minLength
                              "
                              class="lblError"
                              v-text="
                                $ml
                                  .with('f', 5)
                                  .with('l', 5000)
                                  .get('testDescriptionsMustBetweenCharacters')
                              "
                              >A descrição dos testes deve ter entre 5 e 5000
                              caracteres!</label
                            >
                            <label
                              v-else-if="descriptionMaxLengt"
                              class="lblError"
                              v-text="
                                $ml
                                  .with('30.000')
                                  .get('maximumLengthIsCharacters')
                              "
                              >Tamanho máximo é de 30.000 caracteres</label
                            >
                          </transition>
                        </div>
                        <div class="row">
                          <input
                            type="file"
                            id="files"
                            @change="initUpFile($event.target.files)"
                            ref="file"
                            class="file-upload none"
                            name="files"
                            multiple
                          />
                          <div
                            class="col p-2 d-flex flex-column input-files"
                            align="center"
                          >
                            <h3 @click="$refs.file.click()" class="p-3">
                              <font class="p-2" v-text="$ml.get('uploadFiles')"
                                >Enviar arquivos</font
                              >
                              <svg width="20" height="20">
                                <image
                                  xlink:href="../../../../src/assets/icons/paperclip.svg"
                                  width="20"
                                  height="20"
                                />
                              </svg>
                            </h3>
                            <p
                              v-for="(item, index) in listFiles"
                              :key="index"
                              class="p-2 my-1 rounded d-flex flex-row justify-content-between align-items-center"
                            >
                              <span class="row">
                                <input
                                  class="input-none"
                                  :id="'input' + item.id"
                                  :value="'[' + item.id + ']'"
                                />
                                <VueCustomTooltip :label="textTolltip">
                                  <b
                                    @click="copyLink(item.id)"
                                    @mouseout="resetToltip()"
                                    >{{ item.id }}</b
                                  >
                                </VueCustomTooltip>
                                :
                                <span
                                  class="mx-1"
                                  v-text="
                                    item.originalName.substring(0, 40) +
                                    (item.originalName.length > 40
                                      ? '... '
                                      : '')
                                  "
                                ></span>
                                {{ item.sizeFormat }}
                              </span>
                              <svg
                                @click="removeFile(index)"
                                width="14"
                                height="14"
                              >
                                <image
                                  xlink:href="../../../../src/assets/icons/times.svg"
                                  width="14"
                                  height="14"
                                />
                              </svg>
                            </p>
                          </div>
                        </div>
                        <transition class="row" name="fade">
                          <label v-if="upload_error" class="py-1 lblError">{{
                            upload_error
                          }}</label>
                          <label
                            v-else
                            class="py-1 lblError text-primary"
                            v-text="$ml.get('allowedFiles')"
                            >Arquivos permitidos: videos e imagens .jpg .jpeg
                            .png</label
                          >
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- submit -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-5"></span>
                </div>
              </div>

              <div class="d-flex align-self-start">
                <div
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>3</span>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="align-self-start mt-1">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('conclude')">Concluir</strong>
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('haveYouReviewedYourReportNow')"
                      >
                        Revisou seu relatório? Então pronto, vamos enviá-lo para
                        análise!
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pt-2 pb-4"></span>
                </div>

                <div class="d-flex" style="flex-direction: column">
                  <RecaptchaV2
                    class="mt-2 mb-2 ml-3"
                    ref="recaptcha"
                    @verify="setRecaptchaToken"
                    @expired="tokenRecaptcha = ''"
                  />

                  <div class="custom-checkbox mb-4 ml-3">
                    <input
                      type="checkbox"
                      id="checkTerms"
                      v-model="checkTerms"
                      name="check"
                    />
                    <label class="form-check-label label-text" for="checkTerms">
                      <font class="m-4">
                        <font style="color: #666"
                          >{{ $ml.get("submitAgreementNotice") }}
                        </font>
                        <router-link
                          :to="'/program/detail?' + programData._id"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ $ml.get("programPolicy") }}
                        </router-link>

                        <span style="color: #666"> </span
                        ><strong>{{ programData.name }}</strong
                        >,
                        <span>{{ $ml.get("ourLabel") }}</span>
                        <a
                          href="https://www.bughunt.com.br/termos-de-uso.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ $ml.get("termsOfUse") }}
                        </a>
                        <span>{{ $ml.get("confirmReadOur") }} </span>
                        <a
                          href="https://bughunt.com.br/codigo-de-conduta.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $ml.get("codeOfConduct") }}</a
                        >
                        {{ $ml.get("and") }}
                        <a
                          href="https://bughunt.com.br/politica-de-privacidade.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $ml.get("privacyPolicy") }}</a
                        >.
                      </font>
                    </label>
                  </div>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-pending"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span class="pt-5"></span></div>
                </div>
                <div class="pl-3 d-flex w-100 align-items-center">
                  <div class="d-flex align-itens-center">
                    <a
                      v-show="loadingBtn"
                      class="btn btn-primary"
                      style="width: 177px"
                    >
                      <Spinner v-show="true" />
                    </a>
                    <button
                      v-show="!loadingBtn"
                      :disabled="!tokenRecaptcha || !checkTerms"
                      @click.once="warningReward(), createReport()"
                      :key="buttonForReview"
                      class="btn"
                      v-text="$ml.get('submitForReview')"
                    >
                      Enviar para Análise
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Cache Report-->
    <b-modal
      id="modal-cache"
      class="modal-analysis pl-3"
      data-bs-keyboard="false"
      hide-header
      footer-bg-variant="light"
      data-bs-backdrop="static"
      aria-hidden="true"
      no-close-on-backdrop
      no-close-on-esc
      @hidden="restoreCache(saveCacheEvent)"
    >
      <b-container fluid="lg">
        <div class="col modal-body">
          <h4 class="m-0">{{ $ml.get("continueReport") }}</h4>
        </div>
      </b-container>

      <div class="d-flex flex-column">
        <p class="mb-3 px-3">
          {{ $ml.get("weTemporarilyStoreYourReport") }}
          <strong>{{ programData.name }}</strong>
        </p>
      </div>
      <div class="d-flex flex-column">
        <p class="mb-3 px-3">{{ $ml.get("doYouWantToContinue") }}</p>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <a
            class="btn float-right btn-outline-extra mx-3"
            @click="$bvModal.hide('modal-cache')"
          >
            {{ $ml.get("clearData") }}
          </a>
          <b-button
            class="float-right"
            variant="primary"
            size="sm"
            @click="(saveCacheEvent = true), $bvModal.hide('modal-cache')"
          >
            {{ $ml.get("continue") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </main>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import Cvss from "../../../components/cvss.vue";
import RecaptchaV2 from "../../../components/recaptchaV2.vue";
import ProgramService from "../../../services/program.service";
import ReportService from "../../../services/report.service";
import { utils } from "../../../utils";
import _ from "lodash";

// const regexURL = utils.regexCheck('URL')
const descriptionMustBeCustomized = utils.descriptionMustBeCustomized;
export default {
  components: {
    RecaptchaV2,
    Cvss,
  },
  data() {
    return {
      checkTerms: false,
      id: "",
      htmlText: "",
      textTolltip: "Copiar link",

      title: "",
      abstract: "",
      description: this.$ml.get("descriptionSubmitReport"),

      descriptionMaxLengt: false,

      cvss: [],
      resetCvss: false,

      selectedImpact: null,
      selectImpact: [
        { id: "low", name: "low" },
        { id: "medium", name: "medium" },
        { id: "high", name: "high" },
        { id: "critical", name: "critical" },
      ],

      selectedScope: null,
      selectScope: [],

      selectedThreat: null,
      selectThreat: [],

      listFiles: [],

      programData: [],

      isLoading: false,
      loadingBtn: false,
      validateError: false,
      upload_error: false,

      buttonForReview: 1,

      saveCacheEvent: false,

      alternativeScope: "",
      alternativeScopeError: false,
      double_reward: [],
      campaign_situation: false,

      selectedScopeType: "web",
      selectScopeType: [
        "url",
        "web",
        "api",
        "mobile-application-android",
        "mobile-application-ios",
        "domain",
        "subdomain",
        "ip",
        "other",
      ],

      hacker: "",
      program: "",
      target: "",
      targetError: false,
      target_settings: [],
      showOriginalText: false,
      tokenRecaptcha: "",
    };
  },

  validations: {
    title: { required, minLength: minLength(5) },
    selectedScope: { required },
    selectedImpact: { required },
    selectedThreat: { required },
    abstract: { required, minLength: minLength(5), maxLength: maxLength(500) },
    description: {
      required,
      minLength: minLength(5),
      descriptionMustBeCustomized,
    },
  },

  watch: {
    selectedScope: function () {
      this.saveCache("selectedScope");
    },
    selectedImpact: function () {
      this.saveCache("selectedImpact");
    },

    description: function () {
      this.saveCache("description");
    },
    target: function () {
      this.targetError = false;
    },
  },

  created() {
    this.id = this.$route.params.id ?? localStorage.getItem("programId");
    localStorage.setItem("programId", this.id);
    this.getCampaing();
  },

  destroyed() {
    localStorage.setItem("target_settings", "");
    this.target_settings = [];
  },

  mounted() {
    if (this.$route.params.program?.target_settings?.active) {
      localStorage.setItem(
        "target_settings",
        JSON.stringify(this.$route.params.program.target_settings)
      );
    }

    this.target_settings = localStorage.getItem("target_settings");
    if (this.target_settings) {
      this.target_settings = JSON.parse(
        localStorage.getItem("target_settings")
      );
    }

    this.changeWeakness("a");
    this.programData = this.$store.getters["getSubmitReport"].program;

    if (this.programData.status === "paused") {
      this.$router.back();
    }

    this.selectScope = [];
    this.programData.scope.forEach((element) => {
      this.selectScope.push({ name: element.description, id: element._id });
    });
    this.selectScope.push({ name: "Outro", id: "isOutOfScope" });

    this.program = this.programData._id;
    this.hacker = this.$store.getters["getUser"].username;
    this.verifyCache();
  },
  computed: {
    targetOptions() {
      return this.target_settings.targets.filter(
        (target) => target.finishedAt === null
      );
    },
  },
  methods: {
    ...mapActions(["setCacheReport", "resetCacheReport"]),

    waitAPI: _.debounce(function (query) {
      this.saveCache("selectedThreat");
      this.changeWeakness(query);
    }, 1000),

    warningReward() {
      let self = this;
      if (
        this.double_reward.campaign_situation == "approved" ||
        this.double_reward.campaign_situation == "in_progress"
      ) {
        Swal.fire({
          icon: "warning",
          title: self.$ml.get("rewardNotice"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3500,
        });
      }
    },

    alterSeverity(severity) {
      this.cvss = severity;

      if (severity.name == "impact-low") {
        this.selectedImpact = { id: "low", name: "low" };
      }
      if (severity.name == "impact-medium") {
        this.selectedImpact = { id: "medium", name: "medium" };
      }
      if (severity.name == "impact-high") {
        this.selectedImpact = { id: "high", name: "high" };
      }
      if (severity.name == "impact-critical") {
        this.selectedImpact = { id: "critical", name: "critical" };
      }
    },

    verifyCache() {
      let getSubmitReport = this.$store.getters["getCacheReport"];
      let hacker = this.$store.getters["getUser"].username;

      if (
        getSubmitReport.program == this.programData.id &&
        getSubmitReport.hacker == hacker &&
        (getSubmitReport.title ||
          getSubmitReport.selectedScope ||
          getSubmitReport.selectedImpact ||
          getSubmitReport.selectedThreat ||
          getSubmitReport.abstract ||
          getSubmitReport.description)
      ) {
        this.$bvModal.show("modal-cache");
      }
    },

    restoreCache(restore) {
      let getSubmitReport = this.$store.getters["getCacheReport"];

      if (restore) {
        if (getSubmitReport.title)
          this.title = utils.b64_to_utf8(getSubmitReport.title);

        if (getSubmitReport.selectedScope)
          this.selectedScope = getSubmitReport.selectedScope;

        if (getSubmitReport.selectedImpact)
          this.selectedImpact = getSubmitReport.selectedImpact;

        if (getSubmitReport.selectedThreat)
          this.selectedThreat = getSubmitReport.selectedThreat;

        if (getSubmitReport.abstract)
          this.abstract = utils.b64_to_utf8(getSubmitReport.abstract);

        if (getSubmitReport.description)
          this.description = utils.b64_to_utf8(getSubmitReport.description);
      }
    },

    saveCache(item) {
      this.setCacheReport({ hacker: this.hacker });
      this.setCacheReport({ program: this.programData.id });

      switch (item) {
        case "title":
          this.setCacheReport({ title: utils.utf8_to_b64(this.title) });
          break;
        case "selectedScope":
          this.setCacheReport({ selectedScope: this.selectedScope });
          break;
        case "selectedImpact":
          this.setCacheReport({ selectedImpact: this.selectedImpact });
          break;
        case "selectedThreat":
          this.setCacheReport({ selectedThreat: this.selectedThreat });
          break;
        case "abstract":
          this.setCacheReport({ abstract: utils.utf8_to_b64(this.abstract) });
          break;
        case "description":
          this.setCacheReport({
            description: utils.utf8_to_b64(this.description),
          });
          break;
      }
    },

    controlTextArea() {
      if (this.description.length > 29900) {
        this.description = this.description.substring(0, 29900);
        this.descriptionMaxLengt = true;
      } else {
        this.descriptionMaxLengt = false;
      }
    },

    nameWithLang({ external_id, type }) {
      return `${external_id} — ${type}`;
    },

    nameLang(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },

    changeWeakness(desc) {
      this.isLoading = true;
      ReportService.getWeakness(desc, 7).then(
        (response) => {
          this.isLoading = false;
          this.selectThreat = response.data;
        },
        () => {}
      );
    },

    async createReport() {
      setTimeout(() => {
        this.buttonForReview++;
      }, 500);

      var self = this;
      this.validateError = false;
      this.upload_error = false;
      this.alternativeScopeError = false;
      this.targetError = false;

      if (this.selectedScope?.id == "isOutOfScope" && !this.alternativeScope) {
        this.alternativeScopeError = true;
      }

      if (this.$v.$invalid || this.alternativeScopeError) {
        if (this.target_settings?.active && !this.target._id) {
          this.targetError = true;
        }
        this.validateError = true;
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("checkOutAllFieldsHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      if (this.target_settings?.active && !this.target._id) {
        this.targetError = true;

        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("checkOutAllFieldsHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      const formData = new FormData();

      this.loadingBtn = true;

      this.listFiles.forEach((element) => {
        formData.append("files", element);
      });

      formData.append("title", this.title);
      formData.append("abstract", this.abstract);

      formData.append("description", utils.utf8_to_b64(this.description));

      formData.append("severity", this.selectedImpact.id);
      formData.append("program", this.programData.id);
      formData.append("weakness", this.selectedThreat._id);
      if(this.selectedScope.id != "isOutOfScope"){
      formData.append("scope", this.selectedScope.id);

      }

      if (this.selectedScope?.id == "isOutOfScope") {
        formData.append("isOutOfScope", "yes");
        formData.append("alternativeScope", this.alternativeScope);
        formData.append(
          "alternativeScopeType",
          this.selectedScopeType ?? "web"
        );
      } else {
        formData.append("isOutOfScope", "no");
      }

      if (this.cvss.score) {
        formData.append("cvssScore", Number(this.cvss.score));
        formData.append("cvss", this.cvss.vector);
      }

      formData.append("tokenRecaptcha", this.tokenRecaptcha);
      formData.append("policy_agreement", this.checkTerms);

      if (this.target) {
        formData.append("target", this.target._id);
      }
      ReportService.postReport(formData)
        .then((response) => {
          Swal.fire({
            title: self.$ml.get("created"),
            text: self.$ml.get("reportCreatedSuccessfully"),
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
            willClose: () => {
              self.$router.push("/report/details?" + response.data._id);
            },
          });
          this.loadingBtn = false;
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.resetCacheReport({
            program: this.program,
            hacker: this.hacker,
            title: "",
            selectedScope: "",
            selectedImpact: "",
            selectedThreat: "",
            abstract: "",
            description: "",
          });
        })
        .catch((error) => {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";

          this.loadingBtn = false;
          if (error.response?.data?.statusCode == 425) {
            Swal.fire({
              icon: "info",
              title: self.$ml.get("notAuthorized"),
              showConfirmButton: false,
              timer: 5000,
            });
            return;
          }

          if (error.response?.data?.message) {
            let msgErr = error.response.data.message;

            if (Array.isArray(error.response.data.message)) {
              msgErr = error.response.data.message[0];
            }

            switch (msgErr) {
              case "O limite diário de relatórios foi atingido!":
                msgErr = self.$ml.get("youReachedLimit");
                break;

              case "O título do relatório não é válido!":
                msgErr = self.$ml.get("reportTitleIsNotValid");
                break;

              case "O resumo do relatório não é válido!":
                msgErr = self.$ml.get("reportSummaryNotValid");
                break;

              case "O conteúdo do relatório não é válido!":
                msgErr = self.$ml.get("reportContentIsNotValid");
                break;

              case "O impacto da vulnerabilidade não é válido!":
                msgErr = self.$ml.get("reportVulnerabilitIsNotValid");
                break;

              case "O impacto da vulnerabilidade não é válido! OTN":
                msgErr =
                  self.$ml.get("reportVulnerabilitIsNotValid") +
                  self.$ml.get("reportCantAcceptEspecialCaracter");
                break;

              case "A criticidade da vulnerabilidade não é válida":
                msgErr = self.$ml.get("reportCriticalityIsNotValid");
                break;

              case "A criticidade da vulnerabilidade não é válida! OTN":
                msgErr =
                  self.$ml.get("reportCriticalityIsNotValid") +
                  self.$ml.get("reportCantAcceptEspecialCaracter");
                break;

              case "O identificador do escopo do relatório não é válido!":
                msgErr = self.$ml.get("reportScopeIsNotValid");
                break;

              case "O identificador do escopo do relatório não é válido! OTN":
                msgErr =
                  self.$ml.get("reportScopeIsNotValid") +
                  self.$ml.get("reportCantAcceptEspecialCaracter");
                break;

              case "O identificador do programa não é válido!":
                msgErr = self.$ml.get("reportIdentifierIsNotValid");
                break;

              case "O identificador do programa não é válido! OTN":
                msgErr =
                  self.$ml.get("reportIdentifierIsNotValid") +
                  self.$ml.get("reportCantAcceptEspecialCaracter");
                break;

              case "O identificador da vulnerabilidade não é válido!":
                msgErr = self.$ml.get(
                  "reportVulnerabilityIdentifierIsNotValid"
                );
                break;

              case "O identificador da vulnerabilidade não é válido! OTN":
                msgErr =
                  self.$ml.get("reportVulnerabilityIdentifierIsNotValid") +
                  self.$ml.get("reportCantAcceptEspecialCaracter");
                break;

              default:
                msgErr = self.$ml.get("unableToSubmittedTheReport");
                break;
            }

            Swal.fire({
              icon: "info",
              html: `<h4>${msgErr}</h4`,
              showConfirmButton: false,
              timer: 10000,
            });
            return;
          }

          Swal.fire({
            icon: "info",
            html: `<h4>${self.$ml.get(
              "doNotUseSpecialCharactersAndMalicious"
            )}</h4`,
            showConfirmButton: false,
            timer: 10000,
          });
        });
    },
    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },

    removeFile(item) {
      document.getElementById("files").value = "";
      this.listFiles.splice(item, 1);
    },

    initUpFile(files) {
      var self = this;
      if (files && files[0]) {
        if (files.length + self.listFiles.length > 10) {
          document.getElementById("files").value = "";

          Swal.fire({
            heightAuto: false,
            html: `<h4 class="mb-1">${self.$ml.get(
              "maximumFilesPerComment"
            )}</h4>
                  <label>
                    ${self.$ml.get("ifYouNeedToSubmitMoreComment")}
                  </label>
                  `,
            customClass: "swal-2fa",
            showCancelButton: false,
            confirmButtonText: self.$ml.get("return"),
            confirmButtonColor: "#730BA9",
          });

          return;
        }

        this.upload_error = false;

        Array.from(files).forEach((element, index) => {
          if (this.$utils.uploadVerify(element)) {
            this.upload_error = this.$utils.uploadVerify(element);
            return;
          }

          let fileSize = element.size.toString();
          let sizeFormat = "";

          if (fileSize.length < 7) {
            sizeFormat = `${Math.round(+fileSize / 1024).toFixed(2)}kb`;
          } else {
            sizeFormat = `${(Math.round(+fileSize / 1024) / 1000).toFixed(
              2
            )}MB`;
          }

          let id =
            "F" + String(element.lastModified * (index + 3)).substr(4, 4);
          let originalName = element.name;

          let name = JSON.stringify({
            id: id,
            sizeFormat: sizeFormat,
            name: element.name,
          });

          element = new File([element], name, {
            type: element.type,
          });

          element.id = id;
          element.sizeFormat = sizeFormat;
          element.originalName = originalName;

          self.listFiles.push(element);
        });

        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        });
      }
    },

    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(
        this.description,
        this.listFiles
      );
    },

    copyLink(id) {
      var hiddenField = document.getElementById("input" + id);
      hiddenField.select();
      document.execCommand("copy");
      this.textTolltip = "Cole o link no corpo da descrição";
    },

    resetToltip() {
      this.textTolltip = "Copiar link";
    },

    async getCampaing() {
      const response = await ProgramService.getDataCampaing(this.id);
      this.double_reward.offers_double_bounty =
        response.data.offers_double_bounty;
      this.double_reward.offers_double_score =
        response.data.offers_double_score;
      this.double_reward.campaign_initial_date = moment(
        response.data.campaign_initial_date.toString().split("T")[0]
      ).format("DD/MM/YYYY");
      this.double_reward.campaign_final_date = moment(
        response.data.campaign_final_date.toString().split("T")[0]
      ).format("DD/MM/YYYY");
      this.campaign_situation = response.data.campaign_situation;
    },
  },
};
</script>
<style scoped>
.bounty {
  font-weight: 500;
  background: #9e9e9e29;
  padding: 3px 10px;
  border-radius: 5px;
}
.box {
  padding: 10px;
  border: 1px solid #aaaaaa75;
}
/*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}
@keyframes effect {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.3);
  }
  75% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
